import React from "react";
import { useSession } from "../store/session";
import { PageHeader } from "../components/Controls";
import { InspectionsView } from "./InspectionsView";

export default function InspectionsPage() {
  const { session } = useSession();
  const mine = session.operator.role !== "admin";
  return (
    <div className="animate-rise">
      <PageHeader title={mine ? "Mis inspecciones" : "Inspecciones"} subtitle={mine ? "Solo las registradas por este usuario." : "Listado en vivo con filtros, discrepancias y exportación."} />
      <InspectionsView />
    </div>
  );
}
